module.exports = vant;


//////////////////
// WEBPACK FOOTER
// external "vant"
// module id = 144
// module chunks = 75